import React from "react";
import { WizardDialogContext } from "./contextProvider";

function useWizardDialogContext() {
  const context = React.useContext(WizardDialogContext);

  return context;
}

export default useWizardDialogContext;
